import { render, staticRenderFns } from "./infoBar.vue?vue&type=template&id=173ca5a3&scoped=true&"
import script from "./infoBar.vue?vue&type=script&lang=js&"
export * from "./infoBar.vue?vue&type=script&lang=js&"
import style0 from "./infoBar.vue?vue&type=style&index=0&id=173ca5a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173ca5a3",
  null
  
)

export default component.exports